import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Error from "../abstractComponents/error";
import { useRepositoryObject } from "../../backend/hooks/pmxActivity/queryGetRepositoryObject";

interface ParamsAction {
  versionId: string;
}

//this component will redirect the users to the proper PMX activity, given the version ID
export function RepoObject() {
  const versionId = (useParams() as ParamsAction).versionId;

  const { callSingleRepositoryObject, getRepositoryObjectError } =
    useRepositoryObject();

  useEffect(() => {
    if (versionId) {
      callSingleRepositoryObject({
        variables: {
          versionId: versionId
        }
      }).then((response) => {
        if (response.data && response.data.getRepositoryObject) {
          const file = response.data.getRepositoryObject.repositoryObject;
          const url =
            "/activity/" +
            file.repository.mainActivityId +
            encodeURIComponent("/" + file.name) +
            encodeURIComponent(
              "?versionId=" +
                versionId +
                "&repoId=" +
                file.repository.id +
                "&openProperties=true"
            );
          window.location.replace(url);
        }
      });
    }
  }, [versionId]);

  return (
    <>
      <div className="center_div">
        <Spinner animation="border" className="spinner_color" />
        <p>Redirecting...</p>
        {getRepositoryObjectError && <Error error={getRepositoryObjectError} />}
      </div>
    </>
  );
}
